export default "__VITE_ASSET__a53cead0__"